import { BUSCAR_SE_USUARIO_BLOQUEADO_EDICAO_E_REIMPRESAO_CUPOM } from '../../actions/types'

const estadoInicial = {
  habilitadoBloqueioEdicaoPassageiro: false,
  habilitadoBloqueioReimpressaoCupom: false
}

export default function reducerUsuariobloqueadoEdicaoReimpressaoCupom (state = estadoInicial, action) {
  switch (action.type) {
    case BUSCAR_SE_USUARIO_BLOQUEADO_EDICAO_E_REIMPRESAO_CUPOM: {
      return action.payload.data;
    }
    default: {
      return state
    }
  }
}
